class QueueMessage {
    constructor(
        public id: string,
        public type: string,
        public concurrencyGroup: string,
        public queuedAt: string,
        public tries: number,
        public ready: boolean,
        public content: string,
        public lastTry?: string,
        public nextTry?: string,
        public lastError?: string) {
        //
    }

    public static fromPOJO(data: any) {
        return new QueueMessage(
            data.id,
            data.type,
            data.concurrencyGroup,
            data.queuedAt,
            data.tries,
            data.ready,
            data.content,
            data.lastTry,
            data.nextTry,
            data.lastError
        );
    }
}

export default QueueMessage;
